import React from 'react';
import PropTypes from 'prop-types';
import TableHeading from '../../modules/DataTable/components/TableHeading';

function StatisticsSalesHeader(props) {
    function findColumnData(name, filter) {
        if (filter) {
            return props.children.find(element => element.name === filter);
        }
        return props.children.find(element => element.name === name);
    }
    return (
        <thead>
            <tr>
                <th className="ui-table__cell" data-title="expand" />
                <TableHeading
                    data-title="sire"
                    onSort={props.onSort}
                    {...findColumnData(props.columns[1].columnName, props.columns[1].filterBy)}
                    {...props.columns[1]}
                />
                <TableHeading
                    data-title="catd"
                    onSort={props.onSort}
                    {...findColumnData(props.columns[2].columnName, props.columns[2].filterBy)}
                    {...props.columns[2]}
                />
                <TableHeading
                    data-title="offd"
                    onSort={props.onSort}
                    {...findColumnData(props.columns[3].columnName, props.columns[3].filterBy)}
                    {...props.columns[3]}
                />
                <TableHeading
                    data-title="sold_percent"
                    onSort={props.onSort}
                    {...findColumnData(props.columns[4].columnName, props.columns[4].filterBy)}
                    {...props.columns[4]}
                />
                <TableHeading
                    data-title="aggregate_sales"
                    onSort={props.onSort}
                    {...findColumnData(props.columns[5].columnName, props.columns[5].filterBy)}
                    {...props.columns[5]}
                />
                <TableHeading
                    data-title="average"
                    onSort={props.onSort}
                    {...findColumnData(props.columns[6].columnName, props.columns[6].filterBy)}
                    {...props.columns[6]}
                />
                <TableHeading
                    data-title="high"
                    onSort={props.onSort}
                    {...findColumnData(props.columns[7].columnName, props.columns[7].filterBy)}
                    {...props.columns[7]}
                />
                <TableHeading
                    data-title="median"
                    onSort={props.onSort}
                    {...findColumnData(props.columns[8].columnName, props.columns[8].filterBy)}
                    {...props.columns[8]}
                />
                <TableHeading
                    data-title="low"
                    onSort={props.onSort}
                    {...findColumnData(props.columns[9].columnName, props.columns[9].filterBy)}
                    {...props.columns[9]}
                />
            </tr>
        </thead>
    );
}

StatisticsSalesHeader.propTypes = {
    children: PropTypes.array,
    columns: PropTypes.array,
    sortLink: PropTypes.any,
    onSort: PropTypes.func,
    columnName: PropTypes.string,
    filterBy: PropTypes.string
};

export default StatisticsSalesHeader;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/StatisticsSiresHeader.js